import { i18n } from 'i18n';
import { memo } from 'react';
import type {
  CellThreatGroupProps,
  HeaderThreatGroupProps,
} from 'src/features/edr/threat/threat.types';
import ThreatListDevicesCountChip from '../../../../common/components/ThreatListDevicesCountChip';
import HeaderWithTooltip from '../../../../common/components/ThreatListTable/TableHeaderWithTooltip';
import getFormatCount from '../../../../common/utils/get-format-count';

export type DevicesHeaderProps = {
  text: string;
};

export type DevicesCellProps = {
  deviceCount: number;
};

export const DevicesHeader = ({ text }: DevicesHeaderProps) => {
  const tooltip = i18n.t('Devices impacted');

  return <HeaderWithTooltip text={text} tooltip={tooltip} />;
};

export const DevicesCell = memo(({ deviceCount }: DevicesCellProps) => {
  return <ThreatListDevicesCountChip label={getFormatCount(deviceCount)} />;
});

export const renderDevicesHeader = (info: HeaderThreatGroupProps<number>) => {
  const text = info.column.columnDef.meta?.displayName;
  if (!text) return null;

  return <DevicesHeader text={text} />;
};

export const renderDevicesCell = (info: CellThreatGroupProps<number>) => {
  const deviceCount = info.getValue();

  return <DevicesCell deviceCount={deviceCount} />;
};
